var ve = Object.defineProperty;
var we = (t, e, n) => e in t ? ve(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var At = (t, e, n) => we(t, typeof e != "symbol" ? e + "" : e, n);
import { i as ye, n as St, r as Tt, x as be } from "./abstract-base-CdeHT0x1.js";
import { e as xe } from "./query-Brcoqn5X.js";
import { a as zt, p as Ee, d as Ae, m as Se } from "./lifecycle-decorators-VlFt_asj.js";
import { g as Te } from "./uid-HAKIZOcY.js";
const G = Math.min, $ = Math.max, ut = Math.round, at = Math.floor, R = (t) => ({
  x: t,
  y: t
}), Pe = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Le = {
  start: "end",
  end: "start"
};
function Mt(t, e, n) {
  return $(t, G(e, n));
}
function rt(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function q(t) {
  return t.split("-")[0];
}
function st(t) {
  return t.split("-")[1];
}
function te(t) {
  return t === "x" ? "y" : "x";
}
function _t(t) {
  return t === "y" ? "height" : "width";
}
function K(t) {
  return ["top", "bottom"].includes(q(t)) ? "y" : "x";
}
function Wt(t) {
  return te(K(t));
}
function Oe(t, e, n) {
  n === void 0 && (n = !1);
  const o = st(t), i = Wt(t), r = _t(i);
  let s = i === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return e.reference[r] > e.floating[r] && (s = pt(s)), [s, pt(s)];
}
function Re(t) {
  const e = pt(t);
  return [Dt(t), e, Dt(e)];
}
function Dt(t) {
  return t.replace(/start|end/g, (e) => Le[e]);
}
function ke(t, e, n) {
  const o = ["left", "right"], i = ["right", "left"], r = ["top", "bottom"], s = ["bottom", "top"];
  switch (t) {
    case "top":
    case "bottom":
      return n ? e ? i : o : e ? o : i;
    case "left":
    case "right":
      return e ? r : s;
    default:
      return [];
  }
}
function Ce(t, e, n, o) {
  const i = st(t);
  let r = ke(q(t), n === "start", o);
  return i && (r = r.map((s) => s + "-" + i), e && (r = r.concat(r.map(Dt)))), r;
}
function pt(t) {
  return t.replace(/left|right|bottom|top/g, (e) => Pe[e]);
}
function Me(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function ee(t) {
  return typeof t != "number" ? Me(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function dt(t) {
  const {
    x: e,
    y: n,
    width: o,
    height: i
  } = t;
  return {
    width: o,
    height: i,
    top: n,
    left: e,
    right: e + o,
    bottom: n + i,
    x: e,
    y: n
  };
}
function qt(t, e, n) {
  let {
    reference: o,
    floating: i
  } = t;
  const r = K(e), s = Wt(e), a = _t(s), c = q(e), l = r === "y", p = o.x + o.width / 2 - i.width / 2, f = o.y + o.height / 2 - i.height / 2, d = o[a] / 2 - i[a] / 2;
  let u;
  switch (c) {
    case "top":
      u = {
        x: p,
        y: o.y - i.height
      };
      break;
    case "bottom":
      u = {
        x: p,
        y: o.y + o.height
      };
      break;
    case "right":
      u = {
        x: o.x + o.width,
        y: f
      };
      break;
    case "left":
      u = {
        x: o.x - i.width,
        y: f
      };
      break;
    default:
      u = {
        x: o.x,
        y: o.y
      };
  }
  switch (st(e)) {
    case "start":
      u[s] -= d * (n && l ? -1 : 1);
      break;
    case "end":
      u[s] += d * (n && l ? -1 : 1);
      break;
  }
  return u;
}
const De = async (t, e, n) => {
  const {
    placement: o = "bottom",
    strategy: i = "absolute",
    middleware: r = [],
    platform: s
  } = n, a = r.filter(Boolean), c = await (s.isRTL == null ? void 0 : s.isRTL(e));
  let l = await s.getElementRects({
    reference: t,
    floating: e,
    strategy: i
  }), {
    x: p,
    y: f
  } = qt(l, o, c), d = o, u = {}, h = 0;
  for (let g = 0; g < a.length; g++) {
    const {
      name: v,
      fn: m
    } = a[g], {
      x: w,
      y,
      data: x,
      reset: b
    } = await m({
      x: p,
      y: f,
      initialPlacement: o,
      placement: d,
      strategy: i,
      middlewareData: u,
      rects: l,
      platform: s,
      elements: {
        reference: t,
        floating: e
      }
    });
    p = w != null ? w : p, f = y != null ? y : f, u = {
      ...u,
      [v]: {
        ...u[v],
        ...x
      }
    }, b && h <= 50 && (h++, typeof b == "object" && (b.placement && (d = b.placement), b.rects && (l = b.rects === !0 ? await s.getElementRects({
      reference: t,
      floating: e,
      strategy: i
    }) : b.rects), {
      x: p,
      y: f
    } = qt(l, d, c)), g = -1);
  }
  return {
    x: p,
    y: f,
    placement: d,
    strategy: i,
    middlewareData: u
  };
};
async function ne(t, e) {
  var n;
  e === void 0 && (e = {});
  const {
    x: o,
    y: i,
    platform: r,
    rects: s,
    elements: a,
    strategy: c
  } = t, {
    boundary: l = "clippingAncestors",
    rootBoundary: p = "viewport",
    elementContext: f = "floating",
    altBoundary: d = !1,
    padding: u = 0
  } = rt(e, t), h = ee(u), v = a[d ? f === "floating" ? "reference" : "floating" : f], m = dt(await r.getClippingRect({
    element: (n = await (r.isElement == null ? void 0 : r.isElement(v))) == null || n ? v : v.contextElement || await (r.getDocumentElement == null ? void 0 : r.getDocumentElement(a.floating)),
    boundary: l,
    rootBoundary: p,
    strategy: c
  })), w = f === "floating" ? {
    x: o,
    y: i,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, y = await (r.getOffsetParent == null ? void 0 : r.getOffsetParent(a.floating)), x = await (r.isElement == null ? void 0 : r.isElement(y)) ? await (r.getScale == null ? void 0 : r.getScale(y)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, b = dt(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: w,
    offsetParent: y,
    strategy: c
  }) : w);
  return {
    top: (m.top - b.top + h.top) / x.y,
    bottom: (b.bottom - m.bottom + h.bottom) / x.y,
    left: (m.left - b.left + h.left) / x.x,
    right: (b.right - m.right + h.right) / x.x
  };
}
const He = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: n,
      y: o,
      placement: i,
      rects: r,
      platform: s,
      elements: a,
      middlewareData: c
    } = e, {
      element: l,
      padding: p = 0
    } = rt(t, e) || {};
    if (l == null)
      return {};
    const f = ee(p), d = {
      x: n,
      y: o
    }, u = Wt(i), h = _t(u), g = await s.getDimensions(l), v = u === "y", m = v ? "top" : "left", w = v ? "bottom" : "right", y = v ? "clientHeight" : "clientWidth", x = r.reference[h] + r.reference[u] - d[u] - r.floating[h], b = d[u] - r.reference[u], M = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(l));
    let S = M ? M[y] : 0;
    (!S || !await (s.isElement == null ? void 0 : s.isElement(M))) && (S = a.floating[y] || r.floating[h]);
    const tt = x / 2 - b / 2, N = S / 2 - g[h] / 2 - 1, F = G(f[m], N), et = G(f[w], N), B = F, nt = S - g[h] - et, E = S / 2 - g[h] / 2 + tt, Y = Mt(B, E, nt), D = !c.arrow && st(i) != null && E !== Y && r.reference[h] / 2 - (E < B ? F : et) - g[h] / 2 < 0, O = D ? E < B ? E - B : E - nt : 0;
    return {
      [u]: d[u] + O,
      data: {
        [u]: Y,
        centerOffset: E - Y - O,
        ...D && {
          alignmentOffset: O
        }
      },
      reset: D
    };
  }
}), Fe = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var n, o;
      const {
        placement: i,
        middlewareData: r,
        rects: s,
        initialPlacement: a,
        platform: c,
        elements: l
      } = e, {
        mainAxis: p = !0,
        crossAxis: f = !0,
        fallbackPlacements: d,
        fallbackStrategy: u = "bestFit",
        fallbackAxisSideDirection: h = "none",
        flipAlignment: g = !0,
        ...v
      } = rt(t, e);
      if ((n = r.arrow) != null && n.alignmentOffset)
        return {};
      const m = q(i), w = K(a), y = q(a) === a, x = await (c.isRTL == null ? void 0 : c.isRTL(l.floating)), b = d || (y || !g ? [pt(a)] : Re(a)), M = h !== "none";
      !d && M && b.push(...Ce(a, g, h, x));
      const S = [a, ...b], tt = await ne(e, v), N = [];
      let F = ((o = r.flip) == null ? void 0 : o.overflows) || [];
      if (p && N.push(tt[m]), f) {
        const E = Oe(i, s, x);
        N.push(tt[E[0]], tt[E[1]]);
      }
      if (F = [...F, {
        placement: i,
        overflows: N
      }], !N.every((E) => E <= 0)) {
        var et, B;
        const E = (((et = r.flip) == null ? void 0 : et.index) || 0) + 1, Y = S[E];
        if (Y)
          return {
            data: {
              index: E,
              overflows: F
            },
            reset: {
              placement: Y
            }
          };
        let D = (B = F.filter((O) => O.overflows[0] <= 0).sort((O, _) => O.overflows[1] - _.overflows[1])[0]) == null ? void 0 : B.placement;
        if (!D)
          switch (u) {
            case "bestFit": {
              var nt;
              const O = (nt = F.filter((_) => {
                if (M) {
                  const W = K(_.placement);
                  return W === w || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  W === "y";
                }
                return !0;
              }).map((_) => [_.placement, _.overflows.filter((W) => W > 0).reduce((W, me) => W + me, 0)]).sort((_, W) => _[1] - W[1])[0]) == null ? void 0 : nt[0];
              O && (D = O);
              break;
            }
            case "initialPlacement":
              D = a;
              break;
          }
        if (i !== D)
          return {
            reset: {
              placement: D
            }
          };
      }
      return {};
    }
  };
};
async function _e(t, e) {
  const {
    placement: n,
    platform: o,
    elements: i
  } = t, r = await (o.isRTL == null ? void 0 : o.isRTL(i.floating)), s = q(n), a = st(n), c = K(n) === "y", l = ["left", "top"].includes(s) ? -1 : 1, p = r && c ? -1 : 1, f = rt(e, t);
  let {
    mainAxis: d,
    crossAxis: u,
    alignmentAxis: h
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return a && typeof h == "number" && (u = a === "end" ? h * -1 : h), c ? {
    x: u * p,
    y: d * l
  } : {
    x: d * l,
    y: u * p
  };
}
const We = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      var n, o;
      const {
        x: i,
        y: r,
        placement: s,
        middlewareData: a
      } = e, c = await _e(e, t);
      return s === ((n = a.offset) == null ? void 0 : n.placement) && (o = a.arrow) != null && o.alignmentOffset ? {} : {
        x: i + c.x,
        y: r + c.y,
        data: {
          ...c,
          placement: s
        }
      };
    }
  };
}, Ie = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: o,
        placement: i
      } = e, {
        mainAxis: r = !0,
        crossAxis: s = !1,
        limiter: a = {
          fn: (v) => {
            let {
              x: m,
              y: w
            } = v;
            return {
              x: m,
              y: w
            };
          }
        },
        ...c
      } = rt(t, e), l = {
        x: n,
        y: o
      }, p = await ne(e, c), f = K(q(i)), d = te(f);
      let u = l[d], h = l[f];
      if (r) {
        const v = d === "y" ? "top" : "left", m = d === "y" ? "bottom" : "right", w = u + p[v], y = u - p[m];
        u = Mt(w, u, y);
      }
      if (s) {
        const v = f === "y" ? "top" : "left", m = f === "y" ? "bottom" : "right", w = h + p[v], y = h - p[m];
        h = Mt(w, h, y);
      }
      const g = a.fn({
        ...e,
        [d]: u,
        [f]: h
      });
      return {
        ...g,
        data: {
          x: g.x - n,
          y: g.y - o,
          enabled: {
            [d]: r,
            [f]: s
          }
        }
      };
    }
  };
};
function wt() {
  return typeof window < "u";
}
function Z(t) {
  return oe(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function A(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function C(t) {
  var e;
  return (e = (oe(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function oe(t) {
  return wt() ? t instanceof Node || t instanceof A(t).Node : !1;
}
function P(t) {
  return wt() ? t instanceof Element || t instanceof A(t).Element : !1;
}
function k(t) {
  return wt() ? t instanceof HTMLElement || t instanceof A(t).HTMLElement : !1;
}
function jt(t) {
  return !wt() || typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof A(t).ShadowRoot;
}
function ct(t) {
  const {
    overflow: e,
    overflowX: n,
    overflowY: o,
    display: i
  } = L(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + o + n) && !["inline", "contents"].includes(i);
}
function Ne(t) {
  return ["table", "td", "th"].includes(Z(t));
}
function yt(t) {
  return [":popover-open", ":modal"].some((e) => {
    try {
      return t.matches(e);
    } catch {
      return !1;
    }
  });
}
function It(t) {
  const e = Nt(), n = P(t) ? L(t) : t;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((o) => n[o] ? n[o] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !e && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !e && (n.filter ? n.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((o) => (n.willChange || "").includes(o)) || ["paint", "layout", "strict", "content"].some((o) => (n.contain || "").includes(o));
}
function Be(t) {
  let e = I(t);
  for (; k(e) && !Q(e); ) {
    if (It(e))
      return e;
    if (yt(e))
      return null;
    e = I(e);
  }
  return null;
}
function Nt() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Q(t) {
  return ["html", "body", "#document"].includes(Z(t));
}
function L(t) {
  return A(t).getComputedStyle(t);
}
function bt(t) {
  return P(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function I(t) {
  if (Z(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    jt(t) && t.host || // Fallback.
    C(t)
  );
  return jt(e) ? e.host : e;
}
function ie(t) {
  const e = I(t);
  return Q(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : k(e) && ct(e) ? e : ie(e);
}
function ot(t, e, n) {
  var o;
  e === void 0 && (e = []), n === void 0 && (n = !0);
  const i = ie(t), r = i === ((o = t.ownerDocument) == null ? void 0 : o.body), s = A(i);
  if (r) {
    const a = Ht(s);
    return e.concat(s, s.visualViewport || [], ct(i) ? i : [], a && n ? ot(a) : []);
  }
  return e.concat(i, ot(i, [], n));
}
function Ht(t) {
  return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
function re(t) {
  const e = L(t);
  let n = parseFloat(e.width) || 0, o = parseFloat(e.height) || 0;
  const i = k(t), r = i ? t.offsetWidth : n, s = i ? t.offsetHeight : o, a = ut(n) !== r || ut(o) !== s;
  return a && (n = r, o = s), {
    width: n,
    height: o,
    $: a
  };
}
function Bt(t) {
  return P(t) ? t : t.contextElement;
}
function X(t) {
  const e = Bt(t);
  if (!k(e))
    return R(1);
  const n = e.getBoundingClientRect(), {
    width: o,
    height: i,
    $: r
  } = re(e);
  let s = (r ? ut(n.width) : n.width) / o, a = (r ? ut(n.height) : n.height) / i;
  return (!s || !Number.isFinite(s)) && (s = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: s,
    y: a
  };
}
const Ve = /* @__PURE__ */ R(0);
function se(t) {
  const e = A(t);
  return !Nt() || !e.visualViewport ? Ve : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function $e(t, e, n) {
  return e === void 0 && (e = !1), !n || e && n !== A(t) ? !1 : e;
}
function j(t, e, n, o) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const i = t.getBoundingClientRect(), r = Bt(t);
  let s = R(1);
  e && (o ? P(o) && (s = X(o)) : s = X(t));
  const a = $e(r, n, o) ? se(r) : R(0);
  let c = (i.left + a.x) / s.x, l = (i.top + a.y) / s.y, p = i.width / s.x, f = i.height / s.y;
  if (r) {
    const d = A(r), u = o && P(o) ? A(o) : o;
    let h = d, g = Ht(h);
    for (; g && o && u !== h; ) {
      const v = X(g), m = g.getBoundingClientRect(), w = L(g), y = m.left + (g.clientLeft + parseFloat(w.paddingLeft)) * v.x, x = m.top + (g.clientTop + parseFloat(w.paddingTop)) * v.y;
      c *= v.x, l *= v.y, p *= v.x, f *= v.y, c += y, l += x, h = A(g), g = Ht(h);
    }
  }
  return dt({
    width: p,
    height: f,
    x: c,
    y: l
  });
}
function Vt(t, e) {
  const n = bt(t).scrollLeft;
  return e ? e.left + n : j(C(t)).left + n;
}
function ce(t, e, n) {
  n === void 0 && (n = !1);
  const o = t.getBoundingClientRect(), i = o.left + e.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    Vt(t, o)
  )), r = o.top + e.scrollTop;
  return {
    x: i,
    y: r
  };
}
function ze(t) {
  let {
    elements: e,
    rect: n,
    offsetParent: o,
    strategy: i
  } = t;
  const r = i === "fixed", s = C(o), a = e ? yt(e.floating) : !1;
  if (o === s || a && r)
    return n;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = R(1);
  const p = R(0), f = k(o);
  if ((f || !f && !r) && ((Z(o) !== "body" || ct(s)) && (c = bt(o)), k(o))) {
    const u = j(o);
    l = X(o), p.x = u.x + o.clientLeft, p.y = u.y + o.clientTop;
  }
  const d = s && !f && !r ? ce(s, c, !0) : R(0);
  return {
    width: n.width * l.x,
    height: n.height * l.y,
    x: n.x * l.x - c.scrollLeft * l.x + p.x + d.x,
    y: n.y * l.y - c.scrollTop * l.y + p.y + d.y
  };
}
function qe(t) {
  return Array.from(t.getClientRects());
}
function je(t) {
  const e = C(t), n = bt(t), o = t.ownerDocument.body, i = $(e.scrollWidth, e.clientWidth, o.scrollWidth, o.clientWidth), r = $(e.scrollHeight, e.clientHeight, o.scrollHeight, o.clientHeight);
  let s = -n.scrollLeft + Vt(t);
  const a = -n.scrollTop;
  return L(o).direction === "rtl" && (s += $(e.clientWidth, o.clientWidth) - i), {
    width: i,
    height: r,
    x: s,
    y: a
  };
}
function Ye(t, e) {
  const n = A(t), o = C(t), i = n.visualViewport;
  let r = o.clientWidth, s = o.clientHeight, a = 0, c = 0;
  if (i) {
    r = i.width, s = i.height;
    const l = Nt();
    (!l || l && e === "fixed") && (a = i.offsetLeft, c = i.offsetTop);
  }
  return {
    width: r,
    height: s,
    x: a,
    y: c
  };
}
function Ue(t, e) {
  const n = j(t, !0, e === "fixed"), o = n.top + t.clientTop, i = n.left + t.clientLeft, r = k(t) ? X(t) : R(1), s = t.clientWidth * r.x, a = t.clientHeight * r.y, c = i * r.x, l = o * r.y;
  return {
    width: s,
    height: a,
    x: c,
    y: l
  };
}
function Yt(t, e, n) {
  let o;
  if (e === "viewport")
    o = Ye(t, n);
  else if (e === "document")
    o = je(C(t));
  else if (P(e))
    o = Ue(e, n);
  else {
    const i = se(t);
    o = {
      x: e.x - i.x,
      y: e.y - i.y,
      width: e.width,
      height: e.height
    };
  }
  return dt(o);
}
function le(t, e) {
  const n = I(t);
  return n === e || !P(n) || Q(n) ? !1 : L(n).position === "fixed" || le(n, e);
}
function Xe(t, e) {
  const n = e.get(t);
  if (n)
    return n;
  let o = ot(t, [], !1).filter((a) => P(a) && Z(a) !== "body"), i = null;
  const r = L(t).position === "fixed";
  let s = r ? I(t) : t;
  for (; P(s) && !Q(s); ) {
    const a = L(s), c = It(s);
    !c && a.position === "fixed" && (i = null), (r ? !c && !i : !c && a.position === "static" && !!i && ["absolute", "fixed"].includes(i.position) || ct(s) && !c && le(t, s)) ? o = o.filter((p) => p !== s) : i = a, s = I(s);
  }
  return e.set(t, o), o;
}
function Ge(t) {
  let {
    element: e,
    boundary: n,
    rootBoundary: o,
    strategy: i
  } = t;
  const s = [...n === "clippingAncestors" ? yt(e) ? [] : Xe(e, this._c) : [].concat(n), o], a = s[0], c = s.reduce((l, p) => {
    const f = Yt(e, p, i);
    return l.top = $(f.top, l.top), l.right = G(f.right, l.right), l.bottom = G(f.bottom, l.bottom), l.left = $(f.left, l.left), l;
  }, Yt(e, a, i));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function Ke(t) {
  const {
    width: e,
    height: n
  } = re(t);
  return {
    width: e,
    height: n
  };
}
function Qe(t, e, n) {
  const o = k(e), i = C(e), r = n === "fixed", s = j(t, !0, r, e);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = R(0);
  if (o || !o && !r)
    if ((Z(e) !== "body" || ct(i)) && (a = bt(e)), o) {
      const d = j(e, !0, r, e);
      c.x = d.x + e.clientLeft, c.y = d.y + e.clientTop;
    } else i && (c.x = Vt(i));
  const l = i && !o && !r ? ce(i, a) : R(0), p = s.left + a.scrollLeft - c.x - l.x, f = s.top + a.scrollTop - c.y - l.y;
  return {
    x: p,
    y: f,
    width: s.width,
    height: s.height
  };
}
function Pt(t) {
  return L(t).position === "static";
}
function Ut(t, e) {
  if (!k(t) || L(t).position === "fixed")
    return null;
  if (e)
    return e(t);
  let n = t.offsetParent;
  return C(t) === n && (n = n.ownerDocument.body), n;
}
function ae(t, e) {
  const n = A(t);
  if (yt(t))
    return n;
  if (!k(t)) {
    let i = I(t);
    for (; i && !Q(i); ) {
      if (P(i) && !Pt(i))
        return i;
      i = I(i);
    }
    return n;
  }
  let o = Ut(t, e);
  for (; o && Ne(o) && Pt(o); )
    o = Ut(o, e);
  return o && Q(o) && Pt(o) && !It(o) ? n : o || Be(t) || n;
}
const Je = async function(t) {
  const e = this.getOffsetParent || ae, n = this.getDimensions, o = await n(t.floating);
  return {
    reference: Qe(t.reference, await e(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function Ze(t) {
  return L(t).direction === "rtl";
}
const tn = {
  convertOffsetParentRelativeRectToViewportRelativeRect: ze,
  getDocumentElement: C,
  getClippingRect: Ge,
  getOffsetParent: ae,
  getElementRects: Je,
  getClientRects: qe,
  getDimensions: Ke,
  getScale: X,
  isElement: P,
  isRTL: Ze
};
function fe(t, e) {
  return t.x === e.x && t.y === e.y && t.width === e.width && t.height === e.height;
}
function en(t, e) {
  let n = null, o;
  const i = C(t);
  function r() {
    var a;
    clearTimeout(o), (a = n) == null || a.disconnect(), n = null;
  }
  function s(a, c) {
    a === void 0 && (a = !1), c === void 0 && (c = 1), r();
    const l = t.getBoundingClientRect(), {
      left: p,
      top: f,
      width: d,
      height: u
    } = l;
    if (a || e(), !d || !u)
      return;
    const h = at(f), g = at(i.clientWidth - (p + d)), v = at(i.clientHeight - (f + u)), m = at(p), y = {
      rootMargin: -h + "px " + -g + "px " + -v + "px " + -m + "px",
      threshold: $(0, G(1, c)) || 1
    };
    let x = !0;
    function b(M) {
      const S = M[0].intersectionRatio;
      if (S !== c) {
        if (!x)
          return s();
        S ? s(!1, S) : o = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      S === 1 && !fe(l, t.getBoundingClientRect()) && s(), x = !1;
    }
    try {
      n = new IntersectionObserver(b, {
        ...y,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(b, y);
    }
    n.observe(t);
  }
  return s(!0), r;
}
function nn(t, e, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: r = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = o, l = Bt(t), p = i || r ? [...l ? ot(l) : [], ...ot(e)] : [];
  p.forEach((m) => {
    i && m.addEventListener("scroll", n, {
      passive: !0
    }), r && m.addEventListener("resize", n);
  });
  const f = l && a ? en(l, n) : null;
  let d = -1, u = null;
  s && (u = new ResizeObserver((m) => {
    let [w] = m;
    w && w.target === l && u && (u.unobserve(e), cancelAnimationFrame(d), d = requestAnimationFrame(() => {
      var y;
      (y = u) == null || y.observe(e);
    })), n();
  }), l && !c && u.observe(l), u.observe(e));
  let h, g = c ? j(t) : null;
  c && v();
  function v() {
    const m = j(t);
    g && !fe(g, m) && n(), g = m, h = requestAnimationFrame(v);
  }
  return n(), () => {
    var m;
    p.forEach((w) => {
      i && w.removeEventListener("scroll", n), r && w.removeEventListener("resize", n);
    }), f == null || f(), (m = u) == null || m.disconnect(), u = null, c && cancelAnimationFrame(h);
  };
}
const on = We, rn = Ie, sn = Fe, cn = He, ln = (t, e, n) => {
  const o = /* @__PURE__ */ new Map(), i = {
    platform: tn,
    ...n
  }, r = {
    ...i.platform,
    _c: o
  };
  return De(t, e, {
    ...i,
    platform: r
  });
};
var xt = class extends Event {
  constructor(e, { oldState: n = "", newState: o = "", ...i } = {}) {
    super(e, i);
    At(this, "oldState");
    At(this, "newState");
    this.oldState = String(n || ""), this.newState = String(o || "");
  }
}, Xt = /* @__PURE__ */ new WeakMap();
function ue(t, e, n) {
  Xt.set(
    t,
    setTimeout(() => {
      Xt.has(t) && t.dispatchEvent(
        new xt("toggle", {
          cancelable: !1,
          oldState: e,
          newState: n
        })
      );
    }, 0)
  );
}
var $t = globalThis.ShadowRoot || function() {
}, an = globalThis.HTMLDialogElement || function() {
}, ft = /* @__PURE__ */ new WeakMap(), H = /* @__PURE__ */ new WeakMap(), lt = /* @__PURE__ */ new WeakMap();
function ht(t) {
  return lt.get(t) || "hidden";
}
var gt = /* @__PURE__ */ new WeakMap();
function fn(t) {
  const e = t.popoverTargetElement;
  if (!(e instanceof HTMLElement))
    return;
  const n = ht(e);
  t.popoverTargetAction === "show" && n === "showing" || t.popoverTargetAction === "hide" && n === "hidden" || (n === "showing" ? it(e, !0, !0) : z(e, !1) && (gt.set(e, t), Ft(e)));
}
function z(t, e) {
  return !(t.popover !== "auto" && t.popover !== "manual" || !t.isConnected || e && ht(t) !== "showing" || !e && ht(t) !== "hidden" || t instanceof an && t.hasAttribute("open") || document.fullscreenElement === t);
}
function Gt(t) {
  return t ? Array.from(H.get(t.ownerDocument) || []).indexOf(
    t
  ) + 1 : 0;
}
function un(t) {
  const e = pe(t), n = pn(t);
  return Gt(e) > Gt(n) ? e : n;
}
function mt(t) {
  const e = H.get(t);
  for (const n of e || [])
    if (!n.isConnected)
      e.delete(n);
    else
      return n;
  return null;
}
function J(t) {
  return typeof t.getRootNode == "function" ? t.getRootNode() : t.parentNode ? J(t.parentNode) : t;
}
function pe(t) {
  for (; t; ) {
    if (t instanceof HTMLElement && t.popover === "auto" && lt.get(t) === "showing")
      return t;
    if (t = t instanceof Element && t.assignedSlot || t.parentElement || J(t), t instanceof $t && (t = t.host), t instanceof Document) return;
  }
}
function pn(t) {
  for (; t; ) {
    const e = t.popoverTargetElement;
    if (e instanceof HTMLElement) return e;
    if (t = t.parentElement || J(t), t instanceof $t && (t = t.host), t instanceof Document) return;
  }
}
function dn(t) {
  const e = /* @__PURE__ */ new Map();
  let n = 0;
  for (const r of H.get(t.ownerDocument) || [])
    e.set(r, n), n += 1;
  e.set(t, n), n += 1;
  let o = null;
  function i(r) {
    const s = pe(r);
    if (s === null) return null;
    const a = e.get(s);
    (o === null || e.get(o) < a) && (o = s);
  }
  return i(t.parentElement || J(t)), o;
}
function hn(t) {
  return t.hidden || t instanceof $t || (t instanceof HTMLButtonElement || t instanceof HTMLInputElement || t instanceof HTMLSelectElement || t instanceof HTMLTextAreaElement || t instanceof HTMLOptGroupElement || t instanceof HTMLOptionElement || t instanceof HTMLFieldSetElement) && t.disabled || t instanceof HTMLInputElement && t.type === "hidden" || t instanceof HTMLAnchorElement && t.href === "" ? !1 : typeof t.tabIndex == "number" && t.tabIndex !== -1;
}
function gn(t) {
  if (t.shadowRoot && t.shadowRoot.delegatesFocus !== !0)
    return null;
  let e = t;
  e.shadowRoot && (e = e.shadowRoot);
  let n = e.querySelector("[autofocus]");
  if (n)
    return n;
  {
    const r = e.querySelectorAll("slot");
    for (const s of r) {
      const a = s.assignedElements({ flatten: !0 });
      for (const c of a) {
        if (c.hasAttribute("autofocus"))
          return c;
        if (n = c.querySelector("[autofocus]"), n)
          return n;
      }
    }
  }
  const o = t.ownerDocument.createTreeWalker(
    e,
    NodeFilter.SHOW_ELEMENT
  );
  let i = o.currentNode;
  for (; i; ) {
    if (hn(i))
      return i;
    i = o.nextNode();
  }
}
function mn(t) {
  var e;
  (e = gn(t)) == null || e.focus();
}
var vt = /* @__PURE__ */ new WeakMap();
function Ft(t) {
  if (!z(t, !1))
    return;
  const e = t.ownerDocument;
  if (!t.dispatchEvent(
    new xt("beforetoggle", {
      cancelable: !0,
      oldState: "closed",
      newState: "open"
    })
  ) || !z(t, !1))
    return;
  let n = !1;
  if (t.popover === "auto") {
    const i = t.getAttribute("popover"), r = dn(t) || e;
    if (Et(r, !1, !0), i !== t.getAttribute("popover") || !z(t, !1))
      return;
  }
  mt(e) || (n = !0), vt.delete(t);
  const o = e.activeElement;
  t.classList.add(":popover-open"), lt.set(t, "showing"), ft.has(e) || ft.set(e, /* @__PURE__ */ new Set()), ft.get(e).add(t), mn(t), t.popover === "auto" && (H.has(e) || H.set(e, /* @__PURE__ */ new Set()), H.get(e).add(t), de(gt.get(t), !0)), n && o && t.popover === "auto" && vt.set(t, o), ue(t, "closed", "open");
}
function it(t, e = !1, n = !1) {
  var r, s;
  if (!z(t, !0))
    return;
  const o = t.ownerDocument;
  if (t.popover === "auto" && (Et(t, e, n), !z(t, !0)) || (de(gt.get(t), !1), gt.delete(t), n && (t.dispatchEvent(
    new xt("beforetoggle", {
      oldState: "open",
      newState: "closed"
    })
  ), !z(t, !0))))
    return;
  (r = ft.get(o)) == null || r.delete(t), (s = H.get(o)) == null || s.delete(t), t.classList.remove(":popover-open"), lt.set(t, "hidden"), n && ue(t, "open", "closed");
  const i = vt.get(t);
  i && (vt.delete(t), e && i.focus());
}
function Kt(t, e = !1, n = !1) {
  let o = mt(t);
  for (; o; )
    it(o, e, n), o = mt(t);
}
function Et(t, e, n) {
  var s;
  const o = t.ownerDocument || t;
  if (t instanceof Document)
    return Kt(o, e, n);
  let i = null, r = !1;
  for (const a of H.get(o) || [])
    if (a === t)
      r = !0;
    else if (r) {
      i = a;
      break;
    }
  if (!r)
    return Kt(o, e, n);
  for (; i && ht(i) === "showing" && ((s = H.get(o)) != null && s.size); )
    it(i, e, n);
}
var Lt = /* @__PURE__ */ new WeakMap();
function Qt(t) {
  if (!t.isTrusted) return;
  const e = t.composedPath()[0];
  if (!e) return;
  const n = e.ownerDocument;
  if (!mt(n)) return;
  const i = un(e);
  if (i && t.type === "pointerdown")
    Lt.set(n, i);
  else if (t.type === "pointerup") {
    const r = Lt.get(n) === i;
    Lt.delete(n), r && Et(i || n, !1, !0);
  }
}
var Ot = /* @__PURE__ */ new WeakMap();
function de(t, e = !1) {
  if (!t) return;
  Ot.has(t) || Ot.set(t, t.getAttribute("aria-expanded"));
  const n = t.popoverTargetElement;
  if (n instanceof HTMLElement && n.popover === "auto")
    t.setAttribute("aria-expanded", String(e));
  else {
    const o = Ot.get(t);
    o ? t.setAttribute("aria-expanded", o) : t.removeAttribute("aria-expanded");
  }
}
var Jt = globalThis.ShadowRoot || function() {
};
function vn() {
  return typeof HTMLElement < "u" && typeof HTMLElement.prototype == "object" && "popover" in HTMLElement.prototype;
}
function V(t, e, n) {
  const o = t[e];
  Object.defineProperty(t, e, {
    value(i) {
      return o.call(this, n(i));
    }
  });
}
var wn = /(^|[^\\]):popover-open\b/g;
function yn() {
  return typeof globalThis.CSSLayerBlockRule == "function";
}
function bn() {
  const t = yn();
  return `
${t ? "@layer popover-polyfill {" : ""}
  :where([popover]) {
    position: fixed;
    z-index: 2147483647;
    inset: 0;
    padding: 0.25em;
    width: fit-content;
    height: fit-content;
    border-width: initial;
    border-color: initial;
    border-image: initial;
    border-style: solid;
    background-color: canvas;
    color: canvastext;
    overflow: auto;
    margin: auto;
  }

  :where([popover]:not(.\\:popover-open)) {
    display: none;
  }

  :where(dialog[popover].\\:popover-open) {
    display: block;
  }

  :where(dialog[popover][open]) {
    display: revert;
  }

  :where([anchor].\\:popover-open) {
    inset: auto;
  }

  :where([anchor]:popover-open) {
    inset: auto;
  }

  @supports not (background-color: canvas) {
    :where([popover]) {
      background-color: white;
      color: black;
    }
  }

  @supports (width: -moz-fit-content) {
    :where([popover]) {
      width: -moz-fit-content;
      height: -moz-fit-content;
    }
  }

  @supports not (inset: 0) {
    :where([popover]) {
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }
${t ? "}" : ""}
`;
}
var U = null;
function Rt(t) {
  const e = bn();
  if (U === null)
    try {
      U = new CSSStyleSheet(), U.replaceSync(e);
    } catch {
      U = !1;
    }
  if (U === !1) {
    const n = document.createElement("style");
    n.textContent = e, t instanceof Document ? t.head.prepend(n) : t.prepend(n);
  } else
    t.adoptedStyleSheets = [U, ...t.adoptedStyleSheets];
}
function xn() {
  if (typeof window > "u") return;
  window.ToggleEvent = window.ToggleEvent || xt;
  function t(c) {
    return c != null && c.includes(":popover-open") && (c = c.replace(
      wn,
      "$1.\\:popover-open"
    )), c;
  }
  V(Document.prototype, "querySelector", t), V(Document.prototype, "querySelectorAll", t), V(Element.prototype, "querySelector", t), V(Element.prototype, "querySelectorAll", t), V(Element.prototype, "matches", t), V(Element.prototype, "closest", t), V(
    DocumentFragment.prototype,
    "querySelectorAll",
    t
  ), Object.defineProperties(HTMLElement.prototype, {
    popover: {
      enumerable: !0,
      configurable: !0,
      get() {
        if (!this.hasAttribute("popover")) return null;
        const c = (this.getAttribute("popover") || "").toLowerCase();
        return c === "" || c == "auto" ? "auto" : "manual";
      },
      set(c) {
        c === null ? this.removeAttribute("popover") : this.setAttribute("popover", c);
      }
    },
    showPopover: {
      enumerable: !0,
      configurable: !0,
      value() {
        Ft(this);
      }
    },
    hidePopover: {
      enumerable: !0,
      configurable: !0,
      value() {
        it(this, !0, !0);
      }
    },
    togglePopover: {
      enumerable: !0,
      configurable: !0,
      value(c) {
        lt.get(this) === "showing" && c === void 0 || c === !1 ? it(this, !0, !0) : (c === void 0 || c === !0) && Ft(this);
      }
    }
  });
  const e = Element.prototype.attachShadow;
  e && Object.defineProperties(Element.prototype, {
    attachShadow: {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value(c) {
        const l = e.call(this, c);
        return Rt(l), l;
      }
    }
  });
  const n = HTMLElement.prototype.attachInternals;
  n && Object.defineProperties(HTMLElement.prototype, {
    attachInternals: {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value() {
        const c = n.call(this);
        return c.shadowRoot && Rt(c.shadowRoot), c;
      }
    }
  });
  const o = /* @__PURE__ */ new WeakMap();
  function i(c) {
    Object.defineProperties(c.prototype, {
      popoverTargetElement: {
        enumerable: !0,
        configurable: !0,
        set(l) {
          if (l === null)
            this.removeAttribute("popovertarget"), o.delete(this);
          else if (l instanceof Element)
            this.setAttribute("popovertarget", ""), o.set(this, l);
          else
            throw new TypeError(
              "popoverTargetElement must be an element or null"
            );
        },
        get() {
          if (this.localName !== "button" && this.localName !== "input" || this.localName === "input" && this.type !== "reset" && this.type !== "image" && this.type !== "button" || this.disabled || this.form && this.type === "submit")
            return null;
          const l = o.get(this);
          if (l && l.isConnected)
            return l;
          if (l && !l.isConnected)
            return o.delete(this), null;
          const p = J(this), f = this.getAttribute("popovertarget");
          return (p instanceof Document || p instanceof Jt) && f && p.getElementById(f) || null;
        }
      },
      popoverTargetAction: {
        enumerable: !0,
        configurable: !0,
        get() {
          const l = (this.getAttribute("popovertargetaction") || "").toLowerCase();
          return l === "show" || l === "hide" ? l : "toggle";
        },
        set(l) {
          this.setAttribute("popovertargetaction", l);
        }
      }
    });
  }
  i(HTMLButtonElement), i(HTMLInputElement);
  const r = (c) => {
    const l = c.composedPath(), p = l[0];
    if (!(p instanceof Element) || p != null && p.shadowRoot)
      return;
    const f = J(p);
    if (!(f instanceof Jt || f instanceof Document))
      return;
    const d = l.find(
      (u) => {
        var h;
        return (h = u.matches) == null ? void 0 : h.call(u, "[popovertargetaction],[popovertarget]");
      }
    );
    if (d) {
      fn(d), c.preventDefault();
      return;
    }
  }, s = (c) => {
    const l = c.key, p = c.target;
    !c.defaultPrevented && p && (l === "Escape" || l === "Esc") && Et(p.ownerDocument, !0, !0);
  };
  ((c) => {
    c.addEventListener("click", r), c.addEventListener("keydown", s), c.addEventListener("pointerdown", Qt), c.addEventListener("pointerup", Qt);
  })(document), Rt(document);
}
const En = ye`:host{background-color:var(--beacon-system-color-background-1);border:0;border-radius:var(--beacon-system-radius-corner-standard);color:var(--beacon-system-color-text-standard);display:revert;inset:unset;margin:unset;overflow:unset;padding:var(--beacon-system-space-cell-contained);position:absolute}.arrow{position:absolute}`;
var An = Object.defineProperty, Sn = Object.getOwnPropertyDescriptor, he = (t) => {
  throw TypeError(t);
}, T = (t, e, n, o) => {
  for (var i = o > 1 ? void 0 : o ? Sn(e, n) : e, r = t.length - 1, s; r >= 0; r--)
    (s = t[r]) && (i = (o ? s(e, n, i) : s(i)) || i);
  return o && i && An(e, n, i), i;
}, ge = (t, e, n) => e.has(t) || he("Cannot " + n), kt = (t, e, n) => (ge(t, e, "read from private field"), n ? n.call(t) : e.get(t)), Zt = (t, e, n) => e.has(t) ? he("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(t) : e.set(t, n), Ct = (t, e, n, o) => (ge(t, e, "write to private field"), e.set(t, n), n);
function kn(t) {
  var e, n;
  let o = class extends t {
    constructor() {
      super(...arguments), Zt(this, e), this.popover = "manual", this.placement = "top", this.fallbackPlacements = void 0, this.arrowPadding = void 0, this.popupTimeout = null, Zt(this, n, !1), this.show = (i) => {
        this.showCallback(i);
      }, this.showCallback = (i) => {
        this.open = !0, this.handleInteractionEvent(i), this.start();
      }, this.hide = (i) => {
        this.hideCallback(i);
      }, this.hideCallback = (i) => {
        this.open = !1, this.handleInteractionEvent(i), this.stop();
      }, this.toggle = (i) => {
        this.popupTimeout && (clearTimeout(this.popupTimeout), this.popupTimeout = null), this.open ? this.hide(i) : this.show(i), this.handleInteractionEvent(i);
      }, this.closeOnEscape = (i) => {
        i.key === "Escape" && this.open && this.hide(i);
      };
    }
    static get popupStyles() {
      return [En];
    }
    get open() {
      return kt(this, n);
    }
    set open(i) {
      Ct(this, n, i), this.open ? this.showPopover() : this.hidePopover();
    }
    // The use of the event for setting the active trigger is why popups differ from modal in that you need to call show, hide, or toggle directly over the open prop
    handleInteractionEvent(i) {
      if (i) {
        const { target: r } = i;
        r instanceof HTMLElement && (this._activeTrigger = r);
      }
    }
    start() {
      this._activeTrigger && (Ct(this, e, nn(
        this._activeTrigger,
        this,
        () => this.position()
      )), this.runOnStart());
    }
    stop() {
      kt(this, e) && (kt(this, e).call(this), Ct(this, e, null)), this.runOnStop();
    }
    /** @abstract */
    runOnStart() {
    }
    /** @abstract */
    runOnStop() {
    }
    getOffset(i) {
      return i.offsetHeight / 2;
    }
    getStaticSideArrowOffset(i, r) {
      return `-${i.offsetWidth}px`;
    }
    /**
     * @link https://codesandbox.io/s/mystifying-kare-ee3hmh?file=/src/index.js - examples of arrow positioning
     */
    position() {
      const i = this.arrow;
      ln(this._activeTrigger, this, {
        placement: this.placement,
        middleware: [
          on(this.getOffset(i)),
          // fallback to the starting position of each axis first when flipping
          sn({
            fallbackAxisSideDirection: "start",
            fallbackPlacements: this.fallbackPlacements
          }),
          // specifying a padding will allow it to move with your screen the specified distance before it flips
          rn({ padding: 8 }),
          // Optional Arrow Padding override for the menu-popover to align with internal padding;
          cn({
            element: i,
            padding: this.arrowPadding ? parseInt(this.arrowPadding) : void 0
          })
        ]
      }).then(
        ({ x: r, y: s, middlewareData: a, placement: c }) => {
          Object.assign(this.style, {
            top: s + "px",
            left: r + "px"
          });
          const l = c.split("-")[0], p = {
            top: "bottom",
            right: "left",
            bottom: "top",
            left: "right"
          }[l];
          if (a.arrow) {
            const { x: f, y: d } = a.arrow;
            Object.assign(i.style, {
              left: f != null ? `${f}px` : "",
              top: d != null ? `${d}px` : "",
              [p]: this.getStaticSideArrowOffset(i, p)
            }), i == null || i.setAttribute("data-side", l);
          }
        }
      );
    }
    _renderArrowHTML() {
      return be`<div class="arrow"></div>`;
    }
    /** We need an ID to associate the popup as the describing element for triggers that aren't Beacon buttons. */
    assignAutoID() {
      this.id || (this.id = Te());
    }
    applyPopoverPolyfill() {
      vn() || xn();
    }
    handleEscapeToHide() {
      window.addEventListener("keydown", this.closeOnEscape);
    }
    removeEscapeToHide() {
      window.removeEventListener("keydown", this.closeOnEscape);
    }
  };
  return e = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), T([
    St({ reflect: !0 })
  ], o.prototype, "popover", 2), T([
    St()
  ], o.prototype, "placement", 2), T([
    Tt()
  ], o.prototype, "fallbackPlacements", 2), T([
    Tt()
  ], o.prototype, "arrowPadding", 2), T([
    St({ type: Boolean, reflect: !0 })
  ], o.prototype, "open", 1), T([
    Tt()
  ], o.prototype, "_activeTrigger", 2), T([
    xe(".arrow")
  ], o.prototype, "arrow", 2), T([
    zt
  ], o.prototype, "assignAutoID", 1), T([
    zt
  ], o.prototype, "applyPopoverPolyfill", 1), T([
    Ee
  ], o.prototype, "handleEscapeToHide", 1), T([
    Ae
  ], o.prototype, "removeEscapeToHide", 1), o = T([
    Se("Popup")
  ], o), o;
}
export {
  kn as P
};
